import { createEntitySchemas } from '../../../utils/normalize'

export const INFO = 'info'
export const infoSchemas = createEntitySchemas(INFO)
